import { render } from "./AnomaliesPage.vue?vue&type=template&id=acb80ef2&scoped=true"
import script from "./AnomaliesPage.vue?vue&type=script&lang=js"
export * from "./AnomaliesPage.vue?vue&type=script&lang=js"

import "./AnomaliesPage.vue?vue&type=style&index=0&id=acb80ef2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb80ef2"]])

export default __exports__